export default __webpack_public_path__ + "static/media/KOD0050-min.9fe0eac9.webp";